import { HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';

import { AuditCodes, AuditLevels } from '@app/data/dtos/audit/audit.dto';
import { AuditUseCases, AUDIT_USE_CASES } from '@app/domain/use-cases/audit/audit.use-cases.contract';
import { AlertService } from '@app/services';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
import { decodeResponse } from '@app/shared/utils/utils';

import { MTranslateService } from '@mercadona/core/translate';

import { genericErrors } from '@/entities/constants/handler-error.model';
import { ErrorCodes } from '@/models/error/error.model';

@Injectable({
  providedIn: 'root'
})
export class HandlerErrorService {
  private errorTitle!: string | null;

  #auditUseCases: AuditUseCases = inject(AUDIT_USE_CASES);

  constructor(
    private translateService: MTranslateService,
    private alertService: AlertService
  ) {}

  handleError(error: MSafeAny, request: HttpRequest<MSafeAny>): Observable<never> {
    if (error && error.status !== 418 && request.url.indexOf('/audit') === -1) {
      // infinite loop when '/audit' XHR failed
      // don't audit maintenance status error
      this.#auditUseCases.push({
        level: error.status === ErrorCodes.SECTION_MAINTENANCE ? AuditLevels.INFO : AuditLevels.ERROR,
        message: `handleError: handler error service ${JSON.stringify(error)} from url ${request.url}`,
        status_code: error.status === ErrorCodes.SECTION_MAINTENANCE ? AuditCodes.MAINTENANCE : AuditCodes.ERROR,
        app_component: 'HandlerErrorService'
      });
      this.checkError(error);
      return throwError(() => error);
    }
    return of();
  }

  setErrorTitle(title: string | null) {
    this.errorTitle = title;
  }

  private checkError(error: MSafeAny) {
    error = decodeResponse(error);
    const { code, details } = error.error;

    const errorOcurred = Object.keys(genericErrors).find((errorCode) => code === errorCode);

    if (errorOcurred) {
      const toastError = details || error.error;
      const toastTitle = this.errorTitle || this.translateService.translate('COMMENTS.PUSH.ERROR_TOAST_TITLE');
      const errorToShow = genericErrors[errorOcurred];
      this.alertService.showError(toastTitle, this.translateService.translate(errorToShow, toastError));
    }

    this.setErrorTitle(null);
  }
}
